import { createSolanaAddressId } from '@pkg/solana'
import { matchInstructionPattern } from '../../conditions'
import { unstake } from '../../templates'
import type { SolanaConverter } from '../../type'

/**
 * Vote プログラムの withdraw 命令
 * - Vote アカウント（ステーキングアカウント）から SOL を引き出す取引
 * - Solana のバリデーターへの委任を解除して SOL を取り戻す
 *
 * **生成する Action**
 * - ステーキング解除として unstake action
 * - type = unstake
 * - transfers
 *   - direction = in の native SOL transfer（Vote アカウントから user へ）
 *
 * **条件 (一致すべき pattern)**
 * - instructions
 *   - programId が Vote111111111111111111111111111111111111111 である
 *   - type が withdraw である
 * - destination
 *   - withdraw の destination が relatedAddress 内の address である
 *
 * **判定理由**
 * - programId が Vote111111111111111111111111111111111111111 で、instruction type が withdraw
 * - Vote プログラムの withdraw は、ステーキングされた SOL の引き出し（unstake）操作
 * - Vote アカウントから destination アドレスへの SOL 転送が発生する
 * - withdraw の destination が relatedAddress であることを確認して、ユーザーへの unstake であることを保証
 */
const convertToActions: SolanaConverter = (args) => {
  const { transaction, relatedAddresses } = args

  // instructions - Vote program withdraw instruction pattern
  if (
    !matchInstructionPattern(args, {
      pattern: {
        programId: 'Vote111111111111111111111111111111111111111',
      },
    })
  ) {
    return undefined
  }

  // Check if destination is in relatedAddresses
  const withdrawInstruction = transaction.transaction.message.instructions.find(
    (inst) =>
      inst.programId === 'Vote111111111111111111111111111111111111111' &&
      'parsed' in inst &&
      inst.parsed?.type === 'withdraw',
  )

  if (!withdrawInstruction || !('parsed' in withdrawInstruction)) {
    return undefined
  }

  const destination = withdrawInstruction.parsed?.info?.destination as
    | string
    | undefined

  if (!destination) {
    return undefined
  }

  const destinationId = createSolanaAddressId({ address: destination })
  if (!relatedAddresses.has(destinationId)) {
    return undefined
  }

  // ステーキング解除として unstake template で action 生成
  return unstake(args)
}

export default convertToActions
